// Create a new file: reducers/paymentsDraftReducer.js

const initialState = {
  paymentDetails: null,
  paymentDetailsLoading: false,
};

const paymentsDraftReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PAYMENT_DETAILS":
      return {
        ...state,
        paymentDetails: action.payload.data?action.payload.data: null,
      };

    case "SET_PAYMENT_DETAILS_LOADING":
      return {
        ...state,
        paymentDetailsLoading: action.payload,
      };

    case "RESET_PAYMENT_DETAILS":
      return {
        ...state,
        paymentDetails: null,
        paymentDetailsLoading: false,
      };

    default:
      return state;
  }
};

export default paymentsDraftReducer;